export function formatNumberWithFontWeight(number) {
  if (number === "Unlimited") {
    return <span style={{ fontWeight: 500 }}>Unlimited</span>;
  }
  if (isNaN(number)) {
    return <span>-</span>;
  }
  const formattedValue = parseFloat(number).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const parts = formattedValue.split(".");
  const formattedFraction = <span style={{ fontWeight: 400 }}>{parts[1]}</span>;

  return (
    <span>
      {parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}.{""}
      {formattedFraction}
    </span>
  );
}
